var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.displayable)?_c('div',[_c('v-chip',{staticClass:"white--text mt-2 ml-2",attrs:{"color":_vm.color}},[_c('div',{staticClass:"text-caption d-block text-truncate"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }